var map = {
	"./1.webp": 83417,
	"./2.webp": 3740,
	"./3.webp": 81983,
	"./4.webp": 546,
	"./5.webp": 56109,
	"./6.webp": 60019,
	"./7.webp": 65443,
	"./8.webp": 92486,
	"./9.webp": 62241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98208;